import { render, staticRenderFns } from "./DocumentInfo.vue?vue&type=template&id=4be035a1&"
import script from "./DocumentInfo.vue?vue&type=script&lang=js&"
export * from "./DocumentInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports